import {
  EntityLinks,
  Goal,
  GoalProgressCount,
  GoalSortingMode,
  ID,
  OrderDirection,
} from '@griply/types';

import { getOrderedGoalIds } from '../get-ordered-goal-ids';
import { sortGoals } from '../sort-goals';

export type GetGoalListOrderOptions = {
  goals: Goal[];
  allGoals: Goal[];
  sortMode: GoalSortingMode;
  sortDirection: OrderDirection;
  goalSorting?: ID[] | null;
  taskCounts?: Map<ID, number>;
  goalProgressCounts?: Map<ID, GoalProgressCount>;
  links: EntityLinks;
};

export const getGoalListOrder = ({
  goals,
  allGoals,
  sortMode,
  sortDirection,
  goalSorting,
  taskCounts,
  goalProgressCounts,
  links,
}: GetGoalListOrderOptions): ID[] | undefined => {
  if (sortMode === GoalSortingMode.Custom) {
    return goalSorting ?? undefined;
  }

  const sorted = sortGoals(goals, {
    allGoals,
    sortMode,
    taskCounts,
    goalProgressCounts,
    links,
  });
  return getOrderedGoalIds(sorted, sortMode, sortDirection, {
    allGoals,
    links,
  });
};
